/* eslint-disable no-mixed-spaces-and-tabs */
import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';
import { touch, stopSubmit } from 'redux-form';
import { notificationInit } from '../../modules/notifications/actions';
import { REQUEST_ERROR_MESSAGE, ORDER_IMPORT_FORM_NAME, IMPORT_ORDERS_FORM_REQUIRED_FIELDS } from './constants';
import { errorHandler } from '../../api/utils';
import { DISMISS_TIME } from '../../api/constants';
import { GET_IMPORT_FILE, setIsImportedFileLoadingAction, GET_DOWNLOAD_ORDERS_TEMPLATE } from './actions';
import { createImportedOrdersGroupRequest } from '../../api/requests';
import { getDataForImportSelector } from './selectors';
import { getOrdersImportsListAction } from '../orders-imports/actions';
import { transformToValidationErrors } from './utils';

export function* getImportFileSaga({ payload: { redirect } }) {
	try {
		yield put(setIsImportedFileLoadingAction(true));

		const dataForSave = yield select(getDataForImportSelector());

		const file = dataForSave.file;

		if (!dataForSave) return;

		const { data, errors, message, toast } = yield call(createImportedOrdersGroupRequest, file);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			redirect();
			yield put(getOrdersImportsListAction({ searchQuery: '' }));
		} else {
			if (errors) {
				yield put(touch(ORDER_IMPORT_FORM_NAME, ...IMPORT_ORDERS_FORM_REQUIRED_FIELDS));
				yield put(stopSubmit(ORDER_IMPORT_FORM_NAME, transformToValidationErrors(errors)));
			}

			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsImportedFileLoadingAction(false));
	}
}

export function* getDownloadOrdersTemplateSaga() {
	try {
		saveAs('https://docs.mak-logic.ru/template-import-orders.xlsx', 'order_template.xlsx');
	} catch (error) {
		yield fork(errorHandler, error);
	}
}

export default function* ordersImportsModalSaga() {
	yield takeEvery(GET_IMPORT_FILE, getImportFileSaga);
	yield takeEvery(GET_DOWNLOAD_ORDERS_TEMPLATE, getDownloadOrdersTemplateSaga);
}
